import { useQuery } from '@apollo/client';
import { useToast } from '@synoptic/ui-kit/toast/toast-provider.js';
import { StreamPackageCardFragmentFragment } from '@/__generated__/graphql';
import { gql } from '@/__generated__/index.ts';

export const BestDealsForYouQuery = gql(`
  query BestDealsForYouQuery($limit: Int!, $nextToken: String) {
    streamPackages(
      queryType: FEATURED
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        ...StreamPackageCardFragment
        includedStreams {
          ...StreamCardFragment
        }
      }
      nextToken
    }
  }
`);

export const useBestDeals = ({
  limit = 4,
  nextToken,
}: {
  limit?: number;
  nextToken?: string;
} = {}) => {
  const toast = useToast();
  const { data, refetch, loading, error } = useQuery(BestDealsForYouQuery, {
    variables: {
      limit,
      nextToken: nextToken || null,
    },
    onError: () => {
      toast.error({
        title: 'Failed to fetch best deals',
      });
    },
  });

  return {
    streamPackages: data?.streamPackages?.items as
      | StreamPackageCardFragmentFragment[]
      | null,
    areStreamPackagesEmpty: data?.streamPackages?.items?.length === 0,
    nextToken: data?.streamPackages?.nextToken,
    loading,
    refetch,
    error,
  };
};
